"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMinLengthConstraint = void 0;
const isMinLengthConstraint = (constraint) => {
    return constraint.name === 'minLength';
};
exports.isMinLengthConstraint = isMinLengthConstraint;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWluLWxlbmd0aC5jb25zdHJhaW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0cmFpbnRzL21pbi1sZW5ndGguY29uc3RyYWludC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFPTyxNQUFNLHFCQUFxQixHQUFHLENBQUMsVUFBMEIsRUFBcUMsRUFBRTtJQUNyRyxPQUFPLFVBQVUsQ0FBQyxJQUFJLEtBQUssV0FBVyxDQUFBO0FBQ3hDLENBQUMsQ0FBQTtBQUZZLFFBQUEscUJBQXFCLHlCQUVqQyJ9